import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteTaskById,
  fetchTaskById,
} from "../../../lib/api/resources/tasks";
import { TaskDetailCard } from "./components/TaskDetailCard";

export const TaskDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["task", id],
    queryFn: () => fetchTaskById(id),
  });

  const deleteTaskMutation = useMutation({
    mutationFn: () => deleteTaskById(id),
    onSuccess: () => {
      navigate(`/claims/tasks`);
      message.success("Taak succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de taak",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <TaskDetailCard
              deleteMutation={deleteTaskMutation}
              task={data}
              isLoading={isLoading}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
